import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Security, useOktaAuth } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import AppContainer from "../../components/AppContainer/AppContainer";
import { oktaConfig } from "../../config/oktaConfig";
import { useDispatch, useSelector } from "react-redux";
import { logout, setUser } from "../../redux/actions/authActions";
import "./AppContainerPage.css";
import { handleTokenRenewal } from "../../utils/authUtils";
import AppHeader from "../AppHeader/AppHeader";
import MainRouter from "../../routes/MainRouter";
import { pingUser } from "../../services/userProfile";
import AppSidebar from "../AppSideBar/AppSideBar";
import { useAppDispatch } from "../../hooks/app";
import { getUserAccess } from "../../redux/actions/users/userAccessAction";
import { LoadingSpinner } from "pepsico-ds";
import { FullStory as FS } from "@fullstory/browser";

const oktaAuth = new OktaAuth(oktaConfig);

const AppContainerPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [authInProgress, setAuthInProgress] = useState(false);
  let initials: any;
  const { displayName } = useSelector((state: any) => state.auth);
  const authState1 = useSelector((state: any) => state.auth);
  if (displayName && typeof displayName === "string") {
    const nameParts = displayName.split(" ");

    initials =
      nameParts.length >= 2
        ? nameParts[0].charAt(0).toUpperCase() +
          nameParts[1].charAt(0).toUpperCase()
        : nameParts[0].charAt(0).toUpperCase();
  }

  const appDispatch = useAppDispatch();
  const handleLoginSuccess = (authState: any) => {
    const { accessToken } = authState;
    const userData = {
      accessToken: accessToken.accessToken,
      email: accessToken.claims.email,
      gpid: accessToken.claims.gpid || accessToken.claims.GPID,
      firstName: accessToken.claims.FirstName,
      lastName: accessToken.claims.LastName,
      displayName: accessToken.claims.displayname,
    };
    FS("setIdentity", {
      uid: userData.gpid,
      properties: {
        fullName: `${accessToken.claims.FirstName} ${accessToken.claims.LastName}`,
        email: userData.email,
      },
    });
    dispatch(setUser(userData));
  };

  useEffect(() => {
    const interval = setInterval(async () => {
      await handleTokenRenewal();
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const { authState } = useOktaAuth();
  useEffect(() => {
    if (authState?.isAuthenticated && !authInProgress) {
      const isAlreadyAuthenticated = localStorage.getItem("isAuthenticated");
      setAuthInProgress(true);
      handleLoginSuccess(authState);
      if (authState1 && !isAlreadyAuthenticated) {
        localStorage.setItem("isAuthenticated", "true");
        pingUser();
      }
      setAuthInProgress(false);
    }
  }, [authState]);

  const handleClose = async (index: number) => {
    if (index === 0) {
      navigate("/my-profile");
    }
    if (index === 1) {
      setLoading(true);
      try {
        localStorage.removeItem("isAuthenticated");
        await oktaAuth.signOut();
        dispatch(logout());
      } catch (error) {
        console.error("Error during logout:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const restoreOriginalUri = async (
    _oktaAuth: OktaAuth,
    originalUri: string | undefined
  ) => {
    oktaAuth.removeOriginalUri();
    navigate(toRelativeUrl(originalUri || "/", window.location.origin));
  };

  // get user role and permission
  useEffect(() => {
    if (authState) {
      if (authState.isAuthenticated) {
        appDispatch(getUserAccess());
      }
    }
  }, [authState, appDispatch]);
  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f3f7fd",
            zIndex: 9999,
          }}
        >
          <LoadingSpinner
            size={{
              height: "40px",
              width: "40px",
            }}
          />
        </div>
      )}
      <>
        {!loading && authState?.accessToken && (
          <div style={{ flexGrow: 1 }}>
            <AppHeader logoutClose={handleClose} />
          </div>
        )}
        {!loading && (
          <div className="page-container">
            {authState?.accessToken && <AppSidebar />}
            <div className="content-container">
              <AppContainer>
                {/* <MainRouter /> */}
                <Outlet />
              </AppContainer>
            </div>
          </div>
        )}
      </>
    </Security>
  );
};

export default AppContainerPage;
